var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"row_ remove-pad\">\n<div class=\"col-sm-2 remove-left-pad\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"contract_type.all\" ng-click=\"$ctrl.goToAll()\"><a>{{'contractType.all_contract_type' | translate}}</a></li>\n<li role=\"presentation\" ui-sref-active=\"active\" ng-show=\"$ctrl.hasACL['create']\" ui-sref=\"contract_type.create\">\n<a>{{'contractType.create_contract_type' | translate}}</a>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-10 remove-right-pad\">\n<ui-view>\n</ui-view></div>\n</div>\n</div>";
var id1="contract_type.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./client/app/components/tnt_billing/components/contract_type/contract_type.html
// module id = 2805
// module chunks = 1